export function initModal(modal, btnModal) {
  if (modal == null) {
    return;
  }

  const close = modal.querySelector('.modal-titre-close');

  btnModal?.addEventListener('click', function () {
    displayModal(modal);
  });

  close.addEventListener('click', function () {
    modal.style.display = 'none';
  });

  // Quand on clic à l'exterieur de la modal
  window.addEventListener('click', function (event) {
    if (event.target === modal) {
      modal.style.display = 'none';
    }
  });
}

export function displayModal(modal) {
  modal.style.display = 'block';
}
